import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Buttons/Button';
import Accordion from './Accordion';
import TextareaInput from './TextareaInput';
import DeleteButton from '../Buttons/DeleteButton';

const AccordionGroup = ({ accordions, addRow, contentIndex, onChangeWrap, deleteInput }) => {
  const handleKeyPress = (e, nestedIndex) => {
    const code = (e.keyCode ? e.keyCode : e.which);
    if (code === 13) { // Enter
      e.preventDefault();
      addRow(contentIndex, nestedIndex);
    }
  };

  return (
    <ul className="freeform-input-group accordion-input-group faux-list">
      {accordions &&
        accordions.map((accordion, index) => (
          <li className="d-flex align-items-center" key={index}>
            <Accordion 
              classes="w-100"
              title={
                <TextareaInput
                  name={`main_content[${contentIndex}].data[${index}].title`}
                  value={accordion.title}
                  placeholder="Click to add a dropdown title"
                  onChange={onChangeWrap({ type: `accordion`, index, fieldName: `title` })}
                  onKeyPress={e => handleKeyPress(e, index)}
                  autoResize
                />
              }
              detail={
                <TextareaInput
                  name={`main_content[${contentIndex}].data[${index}].detail`}
                  value={accordion.detail}
                  placeholder="Click to add dropdown detail"
                  onChange={onChangeWrap({ type: `accordion`, index, fieldName: `detail` })}
                  onKeyPress={e => handleKeyPress(e, index)}
                  autoResize
                />
              }
            />
            {deleteInput &&
              <DeleteButton classes="m-l-2 m-r-0" onClick={(e) => { e.preventDefault(); deleteInput(contentIndex, index); }} />
            }
          </li>
        ))
      }

      <Button size="s" onClick={(e) => { e.preventDefault(); addRow(contentIndex); }}>Add new row</Button>
    </ul>
  );
};

AccordionGroup.propTypes = {
  accordions: PropTypes.array.isRequired,
  addRow: PropTypes.func,
  contentIndex: PropTypes.number,
  onChangeWrap: PropTypes.func.isRequired,
  deleteInput: PropTypes.func,
};

export default AccordionGroup;



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/AccordionGroup.js